import { Building2, Landmark, Building, Home, Target } from "lucide-react";
import { IconMapping } from "./types";
import { carriers } from "@/components/admin/contact-details/sections/policy/constants";

export const getCarrierIcon = (carrier: string): IconMapping => {
  const normalizedCarrier = carrier.toLowerCase();
  
  // Specific carrier mappings
  if (normalizedCarrier.includes('national general')) {
    return { icon: Building2, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('geico')) {
    return { icon: Target, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('travelers')) {
    return { icon: Building, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('mercury')) {
    return { icon: Home, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('universal')) {
    return { icon: Building2, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('foremost')) {
    return { icon: Target, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('progressive')) {
    return { icon: Building, color: "text-purple-600" };
  }
  
  if (normalizedCarrier.includes('bryton')) {
    return { icon: Home, color: "text-purple-600" };
  }
  
  // Default fallback
  return { icon: Landmark, color: "text-purple-600" };
};